import React, { FC, memo, useMemo } from 'react'

import { ProjectStatusItem } from 'src/components/molecules'

import { ProjectStatusType } from 'src/types'

type Props = {
  projectStatusNames: Pick<ProjectStatusType, 'name'>[]
  hasArchived?: boolean
  className?: string
}

export const ProjectStatus: FC<Props> = memo(({ projectStatusNames, hasArchived, className }) => {
  const activeProjectCount = useMemo(
    () => projectStatusNames.filter(status => status.name === 'active').length,
    [projectStatusNames]
  )
  const preparingProjectCount = useMemo(
    () => projectStatusNames.filter(status => status.name === 'preparing').length,
    [projectStatusNames]
  )
  const archivedProjectCount = useMemo(
    () => projectStatusNames.filter(status => status.name === 'archived').length,
    [projectStatusNames]
  )
  const stoppedProjectCount = useMemo(
    () => projectStatusNames.filter(status => status.name === 'stopped').length,
    [projectStatusNames]
  )

  return (
    <div className={className}>
      <div className="tw-flex tw-gap-s0">
        <ProjectStatusItem
          text="停止中"
          count={stoppedProjectCount}
          className="tw-text-pattern6-4"
        />
        {hasArchived && (
          <ProjectStatusItem
            text="アーカイブ"
            count={archivedProjectCount}
            className="tw-text-pattern6-5"
          />
        )}
        <ProjectStatusItem
          text="準備中"
          count={preparingProjectCount}
          className="tw-text-pattern6-3"
        />
        <ProjectStatusItem
          text="稼働中"
          count={activeProjectCount}
          className="tw-text-pattern6-2"
        />
      </div>
    </div>
  )
})
